<nav class="flex flex-col h-full p-4 gap-2">
  <div>
    <img src="assets/images/mesgo-image.png" alt="Logo" class="w-42 mx-auto mb-8" />
  </div>
    
  <p-panelmenu [model]="menuItems" [multiple]="true" class="w-full">
    <ng-template #item let-item>
      <a
        class="flex flex-row items-center p-2 cursor-pointer group hover:bg-item menu-item rounded-xl"
        [ngClass]="{'active': activeMenuItem === item.url}"
      >
        <i class="material-symbols-outlined text-sm text-white">
          {{ item.icon }}
        </i>
        <span class="ml-2 font-semibold text-white">
          {{ item.label }}
        </span>

        <!-- Desplegar subítems -->
        @if (item.items?.length) {
          <div class="flex ml-auto items-center text-white">
            @if (item.expanded) {
              <span class="material-symbols-outlined">
                keyboard_arrow_up
              </span>
            }
            @else {
              <span class="material-symbols-outlined">
                keyboard_arrow_down
              </span>
            }
          </div>
        }
      </a>
    </ng-template>
  </p-panelmenu>
</nav>